<template>
    <modal id="finance-advance-payment-modal"
           v-model="showModal"
           size="large"
           :title="$t('advance_payment')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">

        <form @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-12">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('employee')"
                        list-value-field="employee_name"
                        v-model="formData.employee_ids"
                        form-group-class="mb-0"
                        :error-message="$errorMessage(errors, 'employee_ids') || $errorMessage(errors, 'employee_ids.*')"
                        :fetch-url="`${TENANT_SELECTABLE_USER}?without=admin&employee=only&with_auth=yes`"
                    />
                </div>
                <div class="col-md-12 mt-3">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('status')"
                        v-model="formData.status"
                        :options="statusOptions"
                        list-value-field="name"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :text-area-rows="4"
                        :error-message="$errorMessage(errors, 'remark')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {TENANT_SELECTABLE_USER} from "../../../Config/ApiUrl";
import { formDataAssigner } from "../../../../common/Helper/Support/FormHelper";

export default {
    name: "FinanceAdvancePaymentCreate",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        transactionId: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            TENANT_BASE_URL,
            TENANT_SELECTABLE_USER,
            formData: {
                transaction_id: this.transactionId,
                employee_ids: [],
                status: '',
                remark: ''
            },
            statusOptions: [
                {id: 'pending', name: this.$t('pending')},
                {id: 'confirm', name: this.$t('confirm')},
                {id: 'refund', name: this.$t('refund')},
                {id: 'cancel', name: this.$t('cancel')},
            ],
        }
    },
    methods: {
        submitData() {
            this.loading = true;
            const url = `${TENANT_BASE_URL}app/advance-payments`;
            const payload = formDataAssigner(new FormData, this.formData);
            if (this.formData.employee_ids) {
                this.formData.employee_ids.forEach(employee_id => payload.append('employee_ids[]', employee_id));
            }

            this.submitFromFixin('post', url, payload);
        },
        afterSuccess({data}) {
            this.formData = {
                transaction_id: this.transactionId,
                employee_ids: [],
                status: '',
                remark: ''
            };
            $('#finance-advance-payment-modal').modal('hide');
            this.$emit('input', false);
            this.$emit('success');
            this.toastAndReload(data.message, 'finance-transaction-table');
        },
    }
}
</script>
